<template>
    <b-container fluid class="footer">
        <b-row class="justify-content-md-center text-center">
            <b-col cols="12" md="4" class="footerText">
                Dúvidas, sugestões e alertas de erros, favor envie-nos uma mensagem através do nosso <span style="text-decoration:underline; cursor:pointer" @click="showDialogContactMethod()">contato</span>.
            </b-col>

            <b-col cols="12" md="2" class="footerImageLogos">
                <img src="../assets/2018-logo-igarape-branco-PT.png">
            </b-col>

            <b-col cols="12" md="2" class="footerImageLogos">
                <img src="../assets/logo-luminate.png" style="width:130px">
            </b-col>

            <b-col cols="12" md="2" class="footerImageLogos">
                <img src="../assets/galo_da_manha.png" style="width:155px">
            </b-col>

            <b-col cols="12" md="2" class="footerImageLogos">
                <img src="../assets/logo-Konrad-branco-fundo-transp.png">
            </b-col>
        </b-row>

        <md-dialog :md-active.sync="showDialogContact" :md-click-outside-to-close="false">
            <contact class="wrapper-dialog" v-on:showDialogContact="closeDialogContact()" ></contact>
        </md-dialog>

    </b-container>  
</template>

<script>
import contact from '@/components/Contact.vue'
export default {

    data() {
        return {
        showDialogContact: false,
        };
    },

    components: { 
        contact
    },

    methods: {
        showDialogContactMethod(){
            this.$store.commit('setFocusClass', 'focusClass')
            this.showDialogContact= true;
        },
        closeDialogContact(){
            this.$store.commit('setFocusClass', '')
            this.showDialogContact = false;
        }
    }
}
</script>

<style scoped lang="scss">

    $break-small: 420px;
    $break-large: 1200px;

    .footer{

        //position:absolute;
        bottom:0;
        @media screen and (max-width: $break-small) { bottom: -280px; }
        width:100%;    
        
        background-color: #061F77;
        margin-top: 60px;
        

        .footerText{
            font-family: Roboto;
            font-style: normal;
            font-weight: 300;
            font-size: 18px;
            line-height: 21px;
            color: #FFFFFF;
            padding: 25px 0 25px 25px;
            text-align: left;
            @media screen and (max-width: $break-small) { text-align: center; padding: 25px}
            align-self: center;
        }

        .footerImageLogos{
            align-self: center;
            padding: 25px 0px;
            text-align: center;
        }
    }
</style>